import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../SEOHead';
import DesktopNavigation from '../Navigation/DesktopNavigation';
import MobileNavigation from '../Navigation/MobileNavigation';
import Footer from '../Footer/Footer';
import ArticlesList from './ArticlesList';

const ArticlesPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans overflow-x-hidden selection:bg-[#05a5b7] selection:text-white">
      <SEOHead 
        title={t('articles.metaTitle')}
        description={t('articles.metaDescription')}
      />
      
      <DesktopNavigation />
      <MobileNavigation />
      
      <main className="pt-24 xl:pt-32 pb-20">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          
          {/* Header Section */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-gray-900">
              {t('articles.title')} <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#05a5b7] to-blue-600">{t('articles.titleHighlight')}</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 font-light max-w-2xl mx-auto">
              {t('articles.subtitle')}
            </p>
          </div>
          
          {/* Content Section */}
          <div className="min-h-[50vh]">
            <ArticlesList />
          </div>
          
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ArticlesPage;
